<template>
  <div :style="{'margin-top': `${marginTop}px`}">
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    includePromoBanner: {
      type: Boolean,
      default: false
    },
    includeNavigation: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      marginTop: 0
    }
  },
  mounted: function () {
    this.calculateMarginTop()
  },
  methods: {
    calculateMarginTop () {
      let promoBannerHeight = 0
      let navigationHeight = 0

      if (this.includePromoBanner) {
        const promoBanner = document.getElementById('promo-banner')
        promoBannerHeight = promoBanner.clientHeight
      }
      if (this.includeNavigation) {
        const navigation = document.getElementById('navigation')
        navigationHeight = navigation.clientHeight
      }

      this.marginTop = promoBannerHeight + navigationHeight
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/adaptive-container.vue